import type { OfflineAvatarResolution } from '@/app/types';

export const OFFLINE_AVATAR_MAX_TEXT_WEIGHTED_LENGTH = 5000;
export const OFFLINE_AVATAR_MIN_TEXT_CHARACTERS = 10;
export const OFFLINE_AVATAR_MIN_AUDIO_DURATION_SECONDS = 5;
export const OFFLINE_AVATAR_MAX_AUDIO_DURATION_SECONDS = 10 * 60;
export const OFFLINE_AVATAR_MAX_RECORDING_DURATION_SECONDS = 10 * 60;
export const OFFLINE_AVATAR_MAX_AUDIO_FILE_SIZE = 10 * 1024 * 1024;

export const OFFLINE_AVATAR_RESOLUTIONS = ['720p', '1080p', '2k'] as const satisfies readonly OfflineAvatarResolution[];
